import jwtRepository from '@/app/login/repository/jwtRepository'
import { createDeviceId } from '@/shared/lib'

// login
export const jwtSecret =
    'ZGVhZGJlZWYwMDAxMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDM='
export const deviceId = createDeviceId()
// export const deviceId = process.env.REACT_APP_GET_DEVICE_ID
export const loginToken = jwtRepository()
export const loginRouteCodespot = 'login'

export const tempGuestToken =
    'eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsIlVTRVItUFJPRklMRS1JRCI6MX0.eyJleHAiOjE4MjM5NDIwMDYsIm5iZiI6MTc5MjQwNTY0NiwiaWF0IjoxNzkyNDA2MDA2LCJpc3MiOiJ1cm46VG95YUFQSSIsImd1ZXN0IjoxfQ.Ox8TotpBWjjQ_RDqiq8R9sWMuPLVu4DAfTxdyRcS9Lxwu-Xpcp9DQV5HplLzvtiRWHIFGl5kp5T8pFRYQlf0PLaURKs8fV-4GWfnZ63pMtFFq6EHPluTydlJr-vY1X4EYv8zde5fDIaWuiwuWnORuOR-iAt33jZ-TbEj-g0IzmKPlv3z1fEKndRrO-Wgs0VL-pTsWIe5vCsQkZdgWPEFQP9Fm2ZQoUlz3sqsg9kvUdm5pCV3izbRIQB0IfuZ11Q3YG8jhZlKP4YKsz5YtphcOAW-6LEbxF_3QYFwuFmYe0ay-QhtuJBIis_EvHLEwdGHGLYlfYfiqOknstfUMsok5teNO1PnqTOLV6B97xYIC8itgYHPC4glc4rYDPR3xc2IhtDXb6q7MWFhG981gKgP7FmeT5bXRj7RrEt0jdjTpdcsKDrnVl5l0Ns9jHLLL_nkSPj5AfsBJpoFiwjeoLIJ6MzCibGxaS5ScPq9BOwpaWdnHUW-PGdDBXDbQj9U_7JTLmzlb5M_J5CtJhMTeXVaOGDAiFN8tRvKBbDtHVPjJl8f2h1Rbak_UWcUIRmAmcvquDEZYUAI9-_Cg13A8ZbjYsXD5nkWSmIQwI6xfXLcvmd7RMRk301uIu53eo24tFKVyHig9XS8Cu8JVW5h947iP5a3hpm4kpMvGcM-3_U23lw'

// profile
export const getProfilesRoute = 'profiles'
export const setProfileRoute = 'profile'

// favorites
export const favoriteChannelsEndpoint = 'favoritechannels'
export const markFavoriteEndpoint = 'markfavorite'
export const unMarkFavoriteEndpoint = 'unmarkfavorite'

export const checkPINRoute = 'verifypin'
export const getConfigRoute = 'config'
export const getSearchResultsRoute = 'search'
export const maxRequestRetry = 6
export const getChannelsRoute = 'channels'
export const configLsKeyword = 'dottv:config'
export const epgEndpoint = 'epg'

// settings
export const devicesEndpoint = 'eboa/devices'
export const revokeDeviceEndpoint = 'eboa/revokeDevice'
export const nameDeviceEndpoint = 'eboa/nameDevice'
export const newPinEndpoint = 'eboa/pin'
export const newsletterSubscribe = 'eboa/newsletter/subscribe'
export const newsletterUnsubscribe = 'eboa/newsletter/unsubscribe'
export const weatherEndpoint = 'data/cameras/weather'

// epg
export const channelsCategoriesEndpoint = 'channels/categories'
